export default {
  SpecialProponent: 'Χειριστής',
  ExecutiveBoardMember: 'Μέλος Επιτροπής',
  AcademicConsultant: 'Ακαδ. Σύμβ.'
}



// WEBPACK FOOTER //
// ./src/store/shortDictionary.js